import { useEffect, useRef, useState, useMemo } from 'react';

interface UseRotatingMessagesOptions {
  delay?: number;
}

export function useRotatingMessages(
  messages: string[],
  options?: UseRotatingMessagesOptions
): string {
  const { delay = 3000 } = options || {}; // ✅ Default delay: 3000ms

  const safeMessages = useMemo(() => messages.filter(Boolean), [messages]);
  const [index, setIndex] = useState(0);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (safeMessages.length <= 1) {
      return undefined;
    }

    intervalRef.current = setInterval(() => {
      setIndex(prev => (prev + 1) % safeMessages.length);
    }, delay);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [safeMessages, delay]);

  return safeMessages[index] || '';
}
